<template>
  <div class="scrlWrap">
    <Tag 
      v-if="viewStatus" 
      v-for="( tag , i ) in list" 
      :tag="tag" 
    />
    <dl class="noneSrch" v-if="!viewStatus">
      <dt>검색 결과가 없습니다.</dt>
      <dd>플러스 버튼을 눌러 추가해주세요.</dd>
    </dl>
  </div>
</template>

<script>
import TagAddPopComm , { TagAddPopCommMapGetters , TagAddPopCommMapState } from "@TagAddPop/TagAddPopComm"; 
import Tag from "./Tag"; 

export default {
  mixins : [ TagAddPopComm ] , 
  components : {
    Tag , 
  } , 
  data () {
    return {
      viewStatus : true , 
      list : [] , 
    }
  } , 
  watch : {
    tagOptionPopAddListViewBln : {
      deep : true , 
      async handler ( viewBln ) {
        if ( !viewBln ) return ; 
        let { crntTag , crntTag : { name , type , color }} = this ; 
        /**
         * crntTag = {
         *  color : "#9D92C9" , 
         *  name : "재료" , 
         *  type : "MATERIAL" , 
         * }
        */
        // console.log( 'crntTag : ' , crntTag ) ; 
        const data = await this.$wApi.tag.gets({ undefined , type }); 
        let list = data[ type.toLowerCase() ] ; 

        list.sort(function(a, b) {
          return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : a.name.toLowerCase() > b.name.toLowerCase() ? 1 : 0; // 오름차순 
          // return a.name.toLowerCase() > b.name.toLowerCase() ? -1 : a.name.toLowerCase() > b.name.toLowerCase() ? 1 : 0 ; // 내림차순 
        });

        this.setCrntList({ list }) ; 
      } , 
    } , 
    crntList () {
      let { crntList } = this ; 
      let viewStatus = crntList.length != 0 ? true : false ; 
      Object.assign( this , { ...this , 
        list : crntList , 
        viewStatus , 
      }) ; 
    } , 
  },
}
</script>

<style lang="scss" scoped>
  .scrlWrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: auto;
    align-items: flex-start; 
    padding-right: 8px; 

    @include scrlbar;
  }
  .noneSrch {
    display: flex; 
    flex-direction: column; 
    justify-content: center; 
    align-items: center; 
    width: 100%; 
    gap: 14.32px; 

    @include text-prt-m; 

    dt {
      color: $gray-3; 
      font-size: 14px; 
    } 
    dd {
      color: $gray-9; 
      font-size: 12px; 
    }
  }
</style>
